/* eslint-disable camelcase */
/* eslint-disable jsx-quotes */
import React from 'react';
import moment from 'moment';

import ItemOption from '../ItemOption';
import ConfirmationModal from '../../../modals-components/ConfirmationModal';

import './ItemQuestion.css';

export default class ItemQuestionPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    getStatusQuestion({ status }) {
        switch (status) {
            case 'INCOMPLETE':
                return 'Incompleto';
            case 'READY':
                return 'Completo';
            case 'LINKED':
                return 'Vinculado';
            case 'LINKED_ANSWERED':
                return 'Respondido';
            default:
                return 'Não identificado';
        }
    }

    render() {
        const {
            question,
            showContent,
            handleShowContent,
            correct_question_id,
            gotoManageQuestion,
            handleConfirmDisable,
            handlePortalDisable,
            handlePortalRemove,
            handleConfirmRemove,
            showModalConfirmDisable,
            showModalConfirmRemove,
            // gotoDuplicateQuestion,
        } = this.props;

        return (
            <div className="container-item">
                <div className="table-grid-line">
                    <span>
                        <p>{question.title}</p>
                    </span>
                    <span>
                        <p>
                            {this.getStatusQuestion({
                                status: question.status,
                            })}
                        </p>
                    </span>
                    <span>
                        <p> {question.enabled ? 'Ativo' : 'Inativo'}</p>
                    </span>
                    <span>
                        <p>
                            {moment(question.created_at).format('DD/MM/YYYY')}
                        </p>
                    </span>
                    <span>
                        <p>
                            {' '}
                            {moment(question.updated_at).format('DD/MM/YYYY')}
                        </p>
                    </span>
                    <span>
                        <button
                            onClick={() =>
                                handleShowContent({
                                    newValue: showContent ? false : true,
                                })
                            }
                        >
                            {showContent ? 'Ocultar' : 'Detalhes'}
                        </button>
                    </span>
                </div>
                {showContent && (
                    <section className="container-details-question">
                        <p className="title-modal">Detalhes da questão</p>
                        <section className="content-question">
                            <h3>{question.title}</h3>
                            {question.options && question.options.length > 0 ? (
                                question.options.map((item, index) =>
                                    !item.removed ? (
                                        <ItemOption
                                            correct_question_id={
                                                correct_question_id
                                            }
                                            key={index}
                                            option={item}
                                        />
                                    ) : null,
                                )
                            ) : (
                                <p
                                    style={{
                                        textAlign: 'center',
                                        color: 'gray',
                                    }}
                                    className="label-title-option"
                                >
                                    Sem itens adicionados
                                </p>
                            )}
                        </section>
                        <span className="line-buttons-details">
                            <button
                                className="manage-question-btn"
                                type="button"
                                onClick={() => gotoManageQuestion(question.id)}
                            >
                                Editar questão
                            </button>
                            <button
                                className="remove-question-btn"
                                onClick={handlePortalRemove}
                                type="button"
                            >
                                Remover
                            </button>
                            {/* <button
                                className={question.status === 'INCOMPLETE' ? 'disabled-button' : "duplicate-question-btn"}
                                disabled={question.status === 'INCOMPLETE'}
                                onClick={() =>
                                    gotoDuplicateQuestion(question.id)
                                }
                                type="button"
                            >
                                Duplicar
                            </button> */}
                            <button
                                className="disable-question-btn"
                                onClick={handlePortalDisable}
                                type="button"
                            >
                                {question.enabled ? 'Desativar' : 'Ativar'}
                            </button>
                        </span>
                        {showModalConfirmDisable && (
                            <ConfirmationModal
                                handleClickOutPortal={handlePortalDisable}
                                handleConfirm={() =>
                                    handleConfirmDisable(question)
                                }
                                message={`Deseja ${
                                    question.enabled ? 'desativar' : 'ativar'
                                } essa questão?`}
                            />
                        )}
                        {showModalConfirmRemove && (
                            <ConfirmationModal
                                handleClickOutPortal={handlePortalRemove}
                                handleConfirm={() =>
                                    handleConfirmRemove(question.id)
                                }
                                message={'Deseja remover essa questão?'}
                            />
                        )}
                    </section>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/questions-database/components/ItemQuestion/ItemQuestionpresentation.js